import { statusVariants } from 'components/NudosComponents/BordStatus/BordStatus.type';
import { PAYMENT_TYPES } from '../types/orders';

const LIST_OF_PAYMENT_METHODS = [
  PAYMENT_TYPES.TRANSFER_MXN,
  PAYMENT_TYPES.CARD_MXN,
  PAYMENT_TYPES.TRANSFER_USD,
  PAYMENT_TYPES.INTERNATIONAL_CARD,
  PAYMENT_TYPES.TRANSFER_COP,
  PAYMENT_TYPES.CARD_COP,
  PAYMENT_TYPES.TRANSFER_PEN,
  PAYMENT_TYPES.TRANSFER_ARS,
  PAYMENT_TYPES.CARD_USD_LLC,
  PAYMENT_TYPES.CARD_USD_CORP
];

const PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT = [
  PAYMENT_TYPES.CARD_USD_LLC,
  PAYMENT_TYPES.CARD_MXN,
  PAYMENT_TYPES.INTERNATIONAL_CARD,
  PAYMENT_TYPES.CARD_COP,
  PAYMENT_TYPES.CARD_USD_CORP
];

export enum PAYMENT_METHODS_LABELS {
  CREDIT_BORD = 'Crédito Bord'
}

const PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT_ORDERS = [PAYMENT_TYPES.TRANSFER_MXN];

const PAYMENT_METHODS_THAT_REQUIRE_A_QUOTE_UPLOAD = [
  PAYMENT_TYPES.TRANSFER_MXN,
  PAYMENT_TYPES.TRANSFER_USD,
  PAYMENT_TYPES.TRANSFER_COP,
  PAYMENT_TYPES.TRANSFER_ARS
];

export {
  LIST_OF_PAYMENT_METHODS,
  PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT,
  PAYMENT_METHODS_THAT_REQUIRE_A_QUOTE_UPLOAD,
  PAYMENT_METHODS_THAT_SHOW_LINK_AUTOMATED_PAYMENT_ORDERS
};

export const SWR_KEYS = {
  activeOrdeactiveProducts: 'active-or-deactive-products',
  activeOrdeactiveLoadExternalTool: 'active-ordeactive-load-external-tool',
  catalogExchanges: 'exchange',
  countriesList: 'countries-list',
  countriesOpenForSale: 'countries-open-for-sale',
  update_serials: 'update-serials',
  listOfTools: 'list-of-tools',
  listCountries: 'list-countries',
  update_tool: 'update-tool',
  updateManualQuotation: 'update-manual-quotation',
  mentions: 'mentions',
  organizationConfigList: 'organization-config-list',
  updateConfigurationStatus: 'update-configuration-status',
  deleteConfiguration: 'delete-configuration',
  createStockOrder: 'create-stock-order',
  updateStockOrderBillingData: 'update-stock-order-billing-data',
  createStockOrderInvoice: 'create-stock-order-invoice',
  getStockProductAvailability: 'get-stock-product-availability',
  createReservationStock: 'create-reservation-stock',
  cancelReservationStock: 'cancel-reservation-stock',
  listLSTypes: 'list-ls-types',
  createPdfToolInformation: 'create-pdf-tool-information'
};

export const noDataCopy = 'Sin datos';

export const metabaseUrl =
  'https://metabase.nudos.co/question/388-catalogo-activo-para-cargue?Modelo=&Procesador=&Memoria=&Almacenamiento=';

export const metabaseUrlProductStock =
  'https://metabase.nudos.co/question/753-productos-en-stock-propio?Pais=&SKU=&Stock_Id=&Estado=&Serial=';

export const VISUAL_EVIDENCE_FILE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'pdf'];

export const VARIANT_SERVICES_STATUS = {
  complete: 'Completado',
  notComplete: 'No completado',
  pending: 'Por completar'
};
export const renderVariantServicesStatus = ({ variant }: { variant: statusVariants | undefined }) => {
  const defaultVariant = 'default';
  const varianStatus = {
    [VARIANT_SERVICES_STATUS.complete]: 'success',
    [VARIANT_SERVICES_STATUS.notComplete]: 'danger',
    [VARIANT_SERVICES_STATUS.pending]: 'default'
  };

  return varianStatus[variant ?? ''] ?? defaultVariant;
};
